export function openTryonOnce(
  opened: { current: string },
  onOpen: (id: string) => void,
  createId: () => string = () => crypto.randomUUID(),
): string {
  if (opened.current) return opened.current;
  const id = createId();
  // Set the guard before invoking effects so a synchronous rerender or a
  // repeated picker action cannot emit the acquisition milestone twice.
  opened.current = id;
  onOpen(id);
  return id;
}
